import Vue from "vue";
import axios from 'axios'

// save our state (isPanel open or not) 
export const store = Vue.observable({
    isNavOpen: false,
    onlineassessment: '',

});

// export const state = {
//     userIp: null
// }
// We call toggleNav anywhere we need it in our app
export const mutations = {
    toggleNav() {
        store.isNavOpen = !store.isNavOpen
    },
    setAssessment: (val) => store.onlineassessment = val,
    // set_Ip (state, val) {
    //     state.userIp = val
    // }
};

// export const actions = {
//     async getIp({commit}){
//         await axios.get('https://api.ipify.org?format=json')
//         .then(x => {
//             const d = x.data.ip
//             commit('set_Ip', d)
//         })
//     }
// };


// WEBPACK FOOTER //
// ./src/store/store.js